import React from 'react'
import { DepartmentType } from '#src/generated/graphql'
import styles from './styles.css'

interface List {
  [key: string]: string[]
}

const golfBullets = [
  'Send you handpicked club recommendations',
  'Help you compare options',
  'Custom fit your clubs',
  'Share feedback on your swing'
]

const winterBullets = [
  'Send you handpicked gear recommendations',
  'Help you compare options',
  'Find you the best price'
]

const cyclingBullets = [
  'Send you handpicked gear recommendations',
  'Help you compare options',
  'Find you the best price'
]

const yachtBullets = [
  'Send you yacht and crew recommendations',
  'Plan a custom itinerary',
  'Help you compare options',
  'Find you the best price'
]

const genericBullets = [
  'Send you handpicked gear recommendations',
  'Help you compare options',
  'Find you the best price'
]

export const getList = (departmentType: string) => {
  switch (departmentType) {
    case DepartmentType.GOLF:
      return golfBullets
    case DepartmentType.WINTER_SPORTS:
      return winterBullets
    case DepartmentType.CYCLING:
      return cyclingBullets
    case DepartmentType.YACHT_CHARTERS:
      return yachtBullets
    default:
      return genericBullets
  }
}

interface ListProps {
  departmentType?: DepartmentType
}

const List: React.FunctionComponent<ListProps> = ({ departmentType }) => {
  const bullets = (departmentType && getList(departmentType)) || getList('GENERIC')

  return (
    <ul className={styles.list}>
      {bullets.map(bullet => (
        <li className={styles.listItem}>{bullet}</li>
      ))}
    </ul>
  )
}

export default List
